/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var r = /* @__PURE__ */ ((E) => (E.DETAIL_EXPAND = "DETAIL_EXPAND_DETAIL_EXPAND", E.COLLAPSE = "DETAIL_EXPAND_COLLAPSE", E.TOGGLE = "DETAIL_EXPAND_TOGGLE", E.SET = "DETAIL_EXPAND_SET", E))(r || {});
const A = (E, L) => {
  switch (L.type) {
    case "DETAIL_EXPAND_DETAIL_EXPAND":
      return { ...E, [L.id]: !0 };
    case "DETAIL_EXPAND_COLLAPSE":
      return { ...E, [L.id]: !1 };
    case "DETAIL_EXPAND_SET":
      return { ...E, [L.id]: L.payload };
    case "DETAIL_EXPAND_TOGGLE":
      return { ...E, [L.id]: !E[L.id] };
    default:
      return E;
  }
};
export {
  r as DETAIL_EXPAND_ACTION,
  A as detailExpandReducer
};
